import { writable } from 'svelte/store';
import collect from 'collect.js';
import PromotionUser from '@/Models/PromotionUser';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	// eslint-disable-next-line no-unused-vars
	let _store;
	let meta;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getUsersForPromotion(promotion, paginate) {
			set(collect());
			let promotionUser = new PromotionUser();
			promotionUser.resourceUrl = () => {
				return `${promotionUser.baseUrl()}/promotions/${promotion.id}/users`;
			};

			return promotionUser.paginate(paginate.size, paginate.number).then((result) => {
				if (result.meta) {
					meta = result.meta;
				}
				set(result.data);
			});
		},

		getPromotionsForUser(userId, paginate) {
			let promotionUser = new PromotionUser();
			// we need a custom resource URL for this endpoint
			promotionUser.resourceUrl = () => {
				return `${promotionUser.baseUrl()}/users/${userId}/promotions`;
			};

			let results = promotionUser.paginate(paginate.size, paginate.number);
			return results
				.then((result) => {
					meta = result.meta;
					set(result.data);
				})
				.catch((e) => {
					console.error(e);
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
